import React from 'react';

const SliderTable = (props) => {
    return (
        <tr key={props.index} className="image" onClick={() => props.editData(props.item)}>
            {
                props.item.images[0] && props.item.images[0].url ?
                    <td>
                        <img src={props.item.images[0].url} alt="" />
                    </td>
                    : 
                    <td>
                        <img src={window.location.origin + "/assets/images/notavailable2.jpg"} alt="" />
                    </td>
            }
            <td>
                {props.item.name}
            </td>
        </tr>
    );
};

export default SliderTable;